import {
  AUTH_COMPANY_ID,
  AUTH_COMPANY_NAME,
  AUTH_COMPANY_PURPOSE,
  AUTH_COMPLIANCE_EMAIL,
  TCompany,
} from "../modules/company/models";

export const setLocalData = (item: TCompany) => {
  const { id, name, purpose, complianceEmail } = item;
  localStorage.setItem(AUTH_COMPANY_ID, id);
  localStorage.setItem(AUTH_COMPANY_NAME, name);
  localStorage.setItem(AUTH_COMPANY_PURPOSE, purpose);
  localStorage.setItem(AUTH_COMPLIANCE_EMAIL, complianceEmail);
};

export const clearLocalData = () => {
  localStorage.setItem(AUTH_COMPANY_ID, "");
  localStorage.setItem(AUTH_COMPANY_NAME, "");
  localStorage.setItem(AUTH_COMPANY_PURPOSE, "");
  localStorage.setItem(AUTH_COMPLIANCE_EMAIL, "");
};
